export default {
    recentAction(state) {
        return state.recentAction;
    }
}